import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';
import rootSaga from './sagas';

import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: hardSet
};

const initialState = {};
export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

const createStoreWithMiddleware = compose(
  applyMiddleware(routerMiddleware(history), sagaMiddleware)
)(createStore);

const store = createStoreWithMiddleware(
  persistedReducer,
  initialState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export default store;
